{
  "schemaVersion": "0.1.0",
  "locale": "en-US",
  "asOf": "2026-06-24",
  "status": "seed",
  "notes": [
    "This file is a playable question-bank seed for the English MVP.",
    "sourceType=todo_fifa_squad_photo_hydration questions are structural placeholders and are filtered out of production play.",
    "Avoid hard-coding live match data such as current standings, injuries, lineups, or scorer tables."
  ],
  "difficultyScoring": {
    "easy": 1,
    "medium": 2,
    "hard": 3,
    "expert": 4
  },
  "sourceRefs": {
    "fifa_2026_format": "https://www.fifa.com/en/tournaments/mens/worldcup/canadamexicousa2026/articles/fifa-world-cup-2026-format-groups-knockout-stage",
    "fifa_2026_hosts_dates": "https://www.fifa.com/en/tournaments/mens/worldcup/canadamexicousa2026/articles/fifa-world-cup-2026-hosts-cities-dates-usa-mexico-canada",
    "fifa_2026_qualified_teams": "https://www.fifa.com/en/tournaments/mens/worldcup/canadamexicousa2026/articles/fifa-world-cup-26-qualified-teams",
    "fifa_2026_squad_lists": "https://fdp.fifa.org/assetspublic/ce159/pdf/SquadLists-English.pdf?sid=13",
    "ifab_laws_latest": "https://www.theifab.com/laws-of-the-game-documents/",
    "fifa_world_cup_winners": "https://www.fifa.com/en/articles/world-cup-winners-list-fifa-2026-tournament",
    "fifa_just_fontaine_record": "https://www.fifa.com/en/articles/just-fontaine-13-goal-fifa-world-cup-record-sweden-1958-france",
    "historical_static": "https://www.fifa.com/en/articles/world-cup-winners-list-fifa-2026-tournament; https://www.fifa.com/en/tournaments/mens/worldcup/articles/fifa-world-cup-all-time-leading-scorers; https://www.fifa.com/en/articles/diego-maradona-argentina-england-hand-of-god-1986",
    "football_knowledge_static": "https://inside.fifa.com/talent-development/fifa-training-centre; https://www.fifatrainingcentre.com/en/game/tournaments/fcwc/2025/team-analyses/increased-use-of-high-press-and-pressing-strategies.php; https://www.fifatrainingcentre.com/en/game/tournaments/fifa-futsal-world-cup/the-low-block-and-low-press.php"
  },
  "questions": [
    {
      "id": "cw-format-001",
      "category": "current_world_cup",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Which three countries are co-hosting the 2026 FIFA World Cup?",
      "options": [
        "Canada, Mexico, and the United States",
        "United States, Brazil, and Argentina",
        "Canada, France, and Germany",
        "Mexico, Colombia, and the United States"
      ],
      "answer": "Canada, Mexico, and the United States",
      "explanation": "The 2026 FIFA World Cup is co-hosted by Canada, Mexico, and the United States.",
      "sourceType": "fifa_2026_hosts_dates"
    },
    {
      "id": "cw-format-002",
      "category": "current_world_cup",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "How many teams will play in the expanded 2026 FIFA World Cup finals?",
      "options": [
        "32 teams",
        "40 teams",
        "48 teams",
        "64 teams"
      ],
      "answer": "48 teams",
      "explanation": "The 2026 tournament expands the finals to 48 teams.",
      "sourceType": "fifa_2026_format"
    },
    {
      "id": "cw-format-003",
      "category": "current_world_cup",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "What is the basic group-stage structure for the 2026 FIFA World Cup?",
      "options": [
        "8 groups of 4 teams",
        "12 groups of 4 teams",
        "16 groups of 3 teams",
        "6 groups of 8 teams"
      ],
      "answer": "12 groups of 4 teams",
      "explanation": "The 48-team format uses 12 groups of four teams.",
      "sourceType": "fifa_2026_format"
    },
    {
      "id": "cw-format-004",
      "category": "current_world_cup",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "After the 2026 World Cup group stage, which teams advance to the round of 32?",
      "options": [
        "The top two in each group plus the 8 best third-place teams",
        "Only each group winner plus the 20 best runners-up",
        "The top three from every group",
        "The top two plus all host teams"
      ],
      "answer": "The top two in each group plus the 8 best third-place teams",
      "explanation": "The top two from 12 groups make 24 teams, joined by the 8 best third-place teams.",
      "sourceType": "fifa_2026_format"
    },
    {
      "id": "cw-format-005",
      "category": "current_world_cup",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "How many matches are scheduled for the 2026 FIFA World Cup?",
      "options": [
        "64 matches",
        "80 matches",
        "96 matches",
        "104 matches"
      ],
      "answer": "104 matches",
      "explanation": "The 48-team format has 104 matches.",
      "sourceType": "fifa_2026_format"
    },
    {
      "id": "cw-format-006",
      "category": "current_world_cup",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "What is the scheduled opening date of the 2026 FIFA World Cup?",
      "options": [
        "2026-06-11",
        "2026-06-24",
        "2026-07-01",
        "2026-07-19"
      ],
      "answer": "2026-06-11",
      "explanation": "FIFA schedule information lists June 11, 2026 as the opening date.",
      "sourceType": "fifa_2026_hosts_dates"
    },
    {
      "id": "cw-format-007",
      "category": "current_world_cup",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "What is the scheduled date of the 2026 FIFA World Cup final?",
      "options": [
        "2026-07-05",
        "2026-07-12",
        "2026-07-19",
        "2026-08-01"
      ],
      "answer": "2026-07-19",
      "explanation": "FIFA schedule information lists July 19, 2026 as the final date.",
      "sourceType": "fifa_2026_hosts_dates"
    },
    {
      "id": "cw-team-001",
      "category": "current_world_cup",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Which team is one of the 2026 FIFA World Cup hosts?",
      "options": [
        "United States",
        "Italy",
        "Chile",
        "Sweden"
      ],
      "answer": "United States",
      "explanation": "The United States is one of the three host nations for the 2026 World Cup.",
      "sourceType": "fifa_2026_hosts_dates"
    },
    {
      "id": "cw-team-002",
      "category": "current_world_cup",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "New Zealand qualified for the 2026 World Cup through which confederation path?",
      "options": [
        "AFC",
        "CAF",
        "OFC",
        "Concacaf"
      ],
      "answer": "OFC",
      "explanation": "New Zealand qualified through the Oceania Football Confederation path.",
      "sourceType": "fifa_2026_qualified_teams"
    },
    {
      "id": "cw-team-003",
      "category": "current_world_cup",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "Which Asian team appears on FIFA's qualified-teams page for the 2026 World Cup?",
      "options": [
        "Japan",
        "Norway",
        "Peru",
        "Wales"
      ],
      "answer": "Japan",
      "explanation": "Japan is listed among the Asian teams qualified for the 2026 World Cup.",
      "sourceType": "fifa_2026_qualified_teams"
    },
    {
      "id": "cw-team-004",
      "category": "current_world_cup",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "Which set contains only 2026 FIFA World Cup co-hosts?",
      "options": [
        "Canada, Mexico, and the United States",
        "United States, England, and Spain",
        "Mexico, Brazil, and the United States",
        "Canada, Germany, and France"
      ],
      "answer": "Canada, Mexico, and the United States",
      "explanation": "Canada, Mexico, and the United States are the three co-hosts.",
      "sourceType": "fifa_2026_hosts_dates"
    },
    {
      "id": "cw-player-seed-001",
      "category": "player_photo_identification",
      "difficulty": "easy",
      "questionType": "image_single_choice",
      "prompt": "[imageAsset: TODO_FIFA_PLAYER_PHOTO_001] Which player matches this official player photo?",
      "options": [
        "SEED_PLAYER_A",
        "SEED_PLAYER_B",
        "SEED_PLAYER_C",
        "SEED_PLAYER_D"
      ],
      "answer": "SEED_PLAYER_A",
      "explanation": "TODO: Replace SEED_PLAYER_* with FIFA squad data and player photos before enabling this structural placeholder.",
      "sourceType": "todo_fifa_squad_photo_hydration"
    },
    {
      "id": "cw-player-seed-002",
      "category": "player_team_identification",
      "difficulty": "easy",
      "questionType": "image_single_choice",
      "prompt": "[imageAsset: TODO_FIFA_PLAYER_PHOTO_002] Which national team is this player listed with?",
      "options": [
        "SEED_TEAM_A",
        "SEED_TEAM_B",
        "SEED_TEAM_C",
        "SEED_TEAM_D"
      ],
      "answer": "SEED_TEAM_A",
      "explanation": "TODO: Replace this structural placeholder with real teamCode, teamName, and photoUrl values from FIFA squad data.",
      "sourceType": "todo_fifa_squad_photo_hydration"
    },
    {
      "id": "cw-player-seed-003",
      "category": "player_name_identification",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "Which player should match the official nameOnShirt value TODO_SHIRT_NAME_001?",
      "options": [
        "SEED_PLAYER_A",
        "SEED_PLAYER_B",
        "SEED_PLAYER_C",
        "SEED_PLAYER_D"
      ],
      "answer": "SEED_PLAYER_A",
      "explanation": "TODO: Use this structural placeholder only to validate shirt-name to display-name mapping before production data generation.",
      "sourceType": "todo_fifa_squad_photo_hydration"
    },
    {
      "id": "cw-player-seed-004",
      "category": "player_position_identification",
      "difficulty": "medium",
      "questionType": "image_single_choice",
      "prompt": "[imageAsset: TODO_FIFA_PLAYER_PHOTO_003] What is this player's listed position in the official squad data?",
      "options": [
        "Goalkeeper",
        "Defender",
        "Midfielder",
        "Forward"
      ],
      "answer": "Midfielder",
      "explanation": "TODO: Replace this structural placeholder with position answers from real FIFA squad data before enabling it.",
      "sourceType": "todo_fifa_squad_photo_hydration"
    },
    {
      "id": "history-001",
      "category": "world_cup_history",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Which country hosted the first men's World Cup in 1930?",
      "options": [
        "Uruguay",
        "Brazil",
        "Italy",
        "France"
      ],
      "answer": "Uruguay",
      "explanation": "The first men's World Cup was held in Uruguay in 1930.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-002",
      "category": "world_cup_history",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Who won the first men's World Cup in 1930?",
      "options": [
        "Uruguay",
        "Argentina",
        "Brazil",
        "Italy"
      ],
      "answer": "Uruguay",
      "explanation": "Uruguay won the first World Cup on home soil.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-003",
      "category": "world_cup_history",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "Which two World Cup years were not held mainly because of World War II?",
      "options": [
        "1938 and 1942",
        "1942 and 1946",
        "1950 and 1954",
        "1962 and 1966"
      ],
      "answer": "1942 and 1946",
      "explanation": "The 1942 and 1946 World Cups were cancelled because of World War II and its aftermath.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-004",
      "category": "world_cup_history",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "At the end of the 2022 World Cup, which country had won the most men's World Cup titles?",
      "options": [
        "Brazil",
        "Germany",
        "Italy",
        "Argentina"
      ],
      "answer": "Brazil",
      "explanation": "Brazil had won five men's World Cup titles by the end of the 2022 tournament.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-005",
      "category": "world_cup_history",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Which team won the 2022 FIFA World Cup in Qatar?",
      "options": [
        "Argentina",
        "France",
        "Croatia",
        "Morocco"
      ],
      "answer": "Argentina",
      "explanation": "Argentina won the 2022 FIFA World Cup.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-006",
      "category": "world_cup_history",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "Who did Argentina face in the 2022 World Cup final?",
      "options": [
        "France",
        "Brazil",
        "England",
        "Croatia"
      ],
      "answer": "France",
      "explanation": "The 2022 final was Argentina against France.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-007",
      "category": "world_cup_history",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Which team won the 2018 FIFA World Cup in Russia?",
      "options": [
        "France",
        "Croatia",
        "Germany",
        "Belgium"
      ],
      "answer": "France",
      "explanation": "France won the 2018 FIFA World Cup.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-008",
      "category": "world_cup_history",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Which team won the 2014 FIFA World Cup in Brazil?",
      "options": [
        "Germany",
        "Argentina",
        "Netherlands",
        "Brazil"
      ],
      "answer": "Germany",
      "explanation": "Germany won the 2014 FIFA World Cup.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-009",
      "category": "world_cup_history",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Which team won the 2010 FIFA World Cup in South Africa?",
      "options": [
        "Spain",
        "Netherlands",
        "Germany",
        "Uruguay"
      ],
      "answer": "Spain",
      "explanation": "Spain won the 2010 FIFA World Cup.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-010",
      "category": "world_cup_history",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "Which was the first men's World Cup hosted on the African continent?",
      "options": [
        "1998 France World Cup",
        "2002 Korea/Japan World Cup",
        "2010 South Africa World Cup",
        "2014 Brazil World Cup"
      ],
      "answer": "2010 South Africa World Cup",
      "explanation": "The 2010 World Cup in South Africa was the first men's World Cup hosted in Africa.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-011",
      "category": "world_cup_history",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "Diego Maradona's \"Hand of God\" goal came against which team in 1986?",
      "options": [
        "England",
        "West Germany",
        "Italy",
        "Belgium"
      ],
      "answer": "England",
      "explanation": "Maradona's \"Hand of God\" goal came for Argentina against England in 1986.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-012",
      "category": "world_cup_history",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "How many goals did France forward Just Fontaine score at the 1958 World Cup?",
      "options": [
        "9 goals",
        "11 goals",
        "13 goals",
        "16 goals"
      ],
      "answer": "13 goals",
      "explanation": "Just Fontaine scored 13 goals at the 1958 World Cup.",
      "sourceType": "fifa_just_fontaine_record"
    },
    {
      "id": "history-013",
      "category": "world_cup_history",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "How many World Cup goals did Miroslav Klose score in his career?",
      "options": [
        "12 goals",
        "14 goals",
        "16 goals",
        "18 goals"
      ],
      "answer": "16 goals",
      "explanation": "Miroslav Klose scored 16 goals across his World Cup career.",
      "sourceType": "historical_static"
    },
    {
      "id": "history-014",
      "category": "world_cup_history",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "Which team won the 2002 Korea/Japan World Cup?",
      "options": [
        "Brazil",
        "Germany",
        "Turkey",
        "South Korea"
      ],
      "answer": "Brazil",
      "explanation": "Brazil won the 2002 FIFA World Cup.",
      "sourceType": "historical_static"
    },
    {
      "id": "rules-001",
      "category": "football_laws",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "How is regular time normally divided in an association football match?",
      "options": [
        "Two 45-minute halves",
        "Three 30-minute periods",
        "Four 20-minute quarters",
        "One 90-minute period"
      ],
      "answer": "Two 45-minute halves",
      "explanation": "A standard match is normally played in two 45-minute halves.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-002",
      "category": "football_laws",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "Under the IFAB Laws, how long may the half-time interval normally last?",
      "options": [
        "10 minutes",
        "15 minutes",
        "20 minutes",
        "25 minutes"
      ],
      "answer": "15 minutes",
      "explanation": "The half-time interval must not exceed 15 minutes unless competition rules allow otherwise.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-003",
      "category": "football_laws",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "When the whole ball crosses a touchline or goal line, what is the ball's status?",
      "options": [
        "In play",
        "Out of play",
        "Still in play unless the referee whistles",
        "Out only if it crosses the goal line"
      ],
      "answer": "Out of play",
      "explanation": "The ball is out of play when the whole ball crosses a touchline or goal line.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-004",
      "category": "football_laws",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "From which restart can a player not be penalized for offside when receiving the ball directly?",
      "options": [
        "Corner kick",
        "Indirect free kick",
        "Pass from a teammate",
        "Dropped ball"
      ],
      "answer": "Corner kick",
      "explanation": "There is no offside offence when receiving the ball directly from a goal kick, throw-in, or corner kick.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-005",
      "category": "football_laws",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "A teammate throws the ball directly to an attacker in an offside position. Is that an offside offence?",
      "options": [
        "No",
        "Always",
        "Only inside the penalty area",
        "Only if a goal is scored"
      ],
      "answer": "No",
      "explanation": "A player cannot commit an offside offence by receiving the ball directly from a throw-in.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-006",
      "category": "football_laws",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "An indirect free kick goes directly into the opponents' goal. What is the restart?",
      "options": [
        "Goal awarded",
        "Goal kick to the opponents",
        "Retake the indirect free kick",
        "Corner kick to the opponents"
      ],
      "answer": "Goal kick to the opponents",
      "explanation": "An indirect free kick must touch another player before a goal can be awarded.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-007",
      "category": "football_laws",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "A penalty taker kicks the ball and then touches it again before anyone else. What is usually awarded?",
      "options": [
        "Retake for the attacking team",
        "Indirect free kick to the defending team",
        "Play continues",
        "Straight red card"
      ],
      "answer": "Indirect free kick to the defending team",
      "explanation": "The penalty taker may not touch the ball again before it has touched another player.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-008",
      "category": "football_laws",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "What happens when a player receives two yellow cards in the same match?",
      "options": [
        "They keep playing",
        "They are sent off",
        "They receive only a verbal warning",
        "They are automatically substituted"
      ],
      "answer": "They are sent off",
      "explanation": "Two cautions in the same match lead to the player being sent off.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-009",
      "category": "football_laws",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "Where can a goalkeeper normally handle the ball?",
      "options": [
        "Inside their own penalty area",
        "Anywhere in their own half",
        "Inside the centre circle",
        "Inside the opponents' penalty area"
      ],
      "answer": "Inside their own penalty area",
      "explanation": "A goalkeeper's handling privilege is limited to their own penalty area, subject to other restrictions.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-010",
      "category": "football_laws",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "A direct free kick goes directly into the kicker's own goal. What is the restart?",
      "options": [
        "Goal awarded",
        "Corner kick to the opponents",
        "Goal kick to the kicker's team",
        "Retake the direct free kick"
      ],
      "answer": "Corner kick to the opponents",
      "explanation": "A team cannot score directly against itself from a free kick; if it enters their own goal directly, a corner kick is awarded.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-011",
      "category": "football_laws",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "A corner kick goes directly into the opponents' goal. What is the decision?",
      "options": [
        "Goal awarded",
        "Goal kick to the opponents",
        "Retake the corner",
        "Indirect free kick to the defending team"
      ],
      "answer": "Goal awarded",
      "explanation": "A goal may be scored directly from a corner kick against the opponents.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "rules-012",
      "category": "football_laws",
      "difficulty": "expert",
      "questionType": "single_choice",
      "prompt": "A throw-in goes directly into the opponents' goal without touching anyone. What is the restart?",
      "options": [
        "Goal awarded",
        "Goal kick to the opponents",
        "Retake the throw-in",
        "Corner kick to the attacking team"
      ],
      "answer": "Goal kick to the opponents",
      "explanation": "A goal cannot be scored directly from a throw-in; if it enters the opponents' goal, a goal kick is awarded.",
      "sourceType": "ifab_laws_latest"
    },
    {
      "id": "tactics-001",
      "category": "tactics_positions",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "What is a centre-back's main job?",
      "options": [
        "Protect central areas, defend forwards, and help build from the back",
        "Only take corner kicks",
        "Wait only in the opponents' box for crosses",
        "Only take throw-ins"
      ],
      "answer": "Protect central areas, defend forwards, and help build from the back",
      "explanation": "Centre-backs usually defend central areas, mark attackers, and help the team play out from the back.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-002",
      "category": "tactics_positions",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "A defensive midfielder is often called a number 6. Which role best fits that position?",
      "options": [
        "Protect the back line, intercept, and connect defence to attack",
        "Stand fixed on the opponents' goal line",
        "Only take goal kicks",
        "Only play on the wing"
      ],
      "answer": "Protect the back line, intercept, and connect defence to attack",
      "explanation": "A defensive midfielder usually screens the defence, covers space, and links phases of play.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-003",
      "category": "tactics_positions",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "What is the typical difference between a full-back and a winger?",
      "options": [
        "A full-back starts deeper and carries more defensive responsibility",
        "A winger is not allowed to shoot",
        "A full-back is not allowed to assist",
        "They have completely different rule identities"
      ],
      "answer": "A full-back starts deeper and carries more defensive responsibility",
      "explanation": "Full-backs are part of the defensive line, while wingers usually start higher and provide attacking width.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-004",
      "category": "tactics_positions",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "What is a typical behaviour of a false 9?",
      "options": [
        "Dropping from centre-forward areas to receive the ball and create space",
        "Standing fixed in an offside position for long balls",
        "Only defending and never attacking",
        "Not joining passing moves"
      ],
      "answer": "Dropping from centre-forward areas to receive the ball and create space",
      "explanation": "A false 9 drops into midfield to disrupt centre-backs and open space for runners.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-005",
      "category": "tactics_positions",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "What is the direct goal of a high press?",
      "options": [
        "Win the ball back quickly in the opponents' half or build-up area",
        "Drop into the team's own penalty area",
        "Only protect the touchline",
        "Avoid all physical challenges"
      ],
      "answer": "Win the ball back quickly in the opponents' half or build-up area",
      "explanation": "A high press applies pressure up the pitch to force mistakes or rushed long passes.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-006",
      "category": "tactics_positions",
      "difficulty": "medium",
      "questionType": "single_choice",
      "prompt": "What is the main feature of a low defensive block?",
      "options": [
        "The team sits deeper, stays compact, and protects dangerous areas",
        "Every player pushes into the opponents' box",
        "Midfielders are not allowed to track back",
        "The goalkeeper must stand in the centre circle"
      ],
      "answer": "The team sits deeper, stays compact, and protects dangerous areas",
      "explanation": "A low block reduces space behind the defence by dropping deeper and staying compact.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-007",
      "category": "tactics_positions",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "What is most important for a defensive line using an offside trap?",
      "options": [
        "Step up together and communicate",
        "Send the goalkeeper into the opponents' half",
        "Ask forwards to stop moving",
        "Move every midfielder out of the centre"
      ],
      "answer": "Step up together and communicate",
      "explanation": "An offside trap depends on coordinated movement; one defender staying deep can break it.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-008",
      "category": "tactics_positions",
      "difficulty": "easy",
      "questionType": "single_choice",
      "prompt": "What does a 4-3-3 formation name usually mean?",
      "options": [
        "4 defenders, 3 midfielders, and 3 forwards",
        "4 forwards, 3 goalkeepers, and 3 midfielders",
        "4 midfielders, 3 defenders, and 3 goalkeepers",
        "Only 10 players are allowed on the pitch"
      ],
      "answer": "4 defenders, 3 midfielders, and 3 forwards",
      "explanation": "Formation numbers usually start from the defensive line and do not include the goalkeeper.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-009",
      "category": "tactics_positions",
      "difficulty": "hard",
      "questionType": "single_choice",
      "prompt": "In a three-centre-back system, what does a wing-back usually provide?",
      "options": [
        "Wide defensive cover and attacking width",
        "Only central defending",
        "No movement beyond the halfway line",
        "Only taking penalties"
      ],
      "answer": "Wide defensive cover and attacking width",
      "explanation": "Wing-backs cover the flank and usually have more up-and-down responsibility than traditional full-backs.",
      "sourceType": "football_knowledge_static"
    },
    {
      "id": "tactics-010",
      "category": "tactics_positions",
      "difficulty": "expert",
      "questionType": "single_choice",
      "prompt": "In football tactics, what does the half-space usually mean?",
      "options": [
        "The vertical channel between the centre and the wing",
        "The area beyond the goal line",
        "The technical area beside the bench",
        "An area only goalkeepers may use"
      ],
      "answer": "The vertical channel between the centre and the wing",
      "explanation": "The half-space sits between central and wide areas and is often used to receive, turn, and create passing angles.",
      "sourceType": "football_knowledge_static"
    }
  ]
}
